<template>
  <div>
    <div class="my-3">
      <button class="btn btn-link pl-0" @click="back">
        <i class="fas fa-angle-left"></i> Back to Summary
      </button>
    </div>

    <!-- filters -->
    <InsightsDetailsFilters class="mb-4" @filtersApplied="refreshDetails" :key="refreshKey" />

    <!-- details -->
    <InsightsDetails :loading="loading" :wcLoading="wcLoading" @refreshDetails="refreshKey++" />
  </div>
</template>

<script>
import InsightsDetailsFilters from './InsightsDetailsFilters'
import InsightsDetails from './InsightsDetails'
import { createNamespacedHelpers } from 'vuex'

const InsightsDetailsModule = createNamespacedHelpers('insightDetailsv2')
const InsightsModule = createNamespacedHelpers('insightsv2')

export default {
  name: 'DetailsView',
  components: {
    InsightsDetailsFilters,
    InsightsDetails
  },
  data: () => ({
    loading: true,
    wcLoading: true,
    refreshKey: 0
  }),
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    ...InsightsModule.mapGetters(['selectLastSummaryURL'])
  },
  methods: {
    ...InsightsDetailsModule.mapActions(['fetchFeedbackData', 'fetchBreakdown', 'fetchSummaries']),
    back() {
      this.$router.push(this.selectLastSummaryURL)
    },
    refreshDetails() {
      this.loadBasic()
      this.loadSummaries()
    },
    async loadBasic() {
      this.loading = true
      await Promise.all([this.fetchFeedbackData(), this.fetchBreakdown()])
      this.loading = false
    },
    async loadSummaries() {
      this.wcLoading = true
      await this.fetchSummaries()
      this.wcLoading = false
    }
  }
}
</script>
